<template>
    <div>

        <el-button-group>
            <el-button type="primary" :size="size" @click="dialogVisible = true">{{title}}</el-button>
            <el-button type="danger" :size="size" @click="remove" v-if="myValue">清除</el-button>
        </el-button-group>

        

        <el-dialog
                title="提示"
                :visible.sync="dialogVisible">
            <span slot="title">
                {{title}}
            </span>

            <el-input
                    placeholder="查询关键字"
                    v-model="page.key"
                    class="input-with-select"
                    clearable
                    @clear="clear">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>

            <el-table v-loading="page.loading" :data="tableData" ref="dataTable">
                <el-table-column prop="name" label="名称">
                    <template slot-scope="scope" >
                        <div @click="handleCurrentChange(scope.row)">
                            {{scope.row.id}} : {{scope.row.name}}
                            <i v-if="myValue===scope.row.id" class="el-icon-success"></i>
                        </div>

                    </template>
                </el-table-column>
            </el-table>
            <br>
            <div class="text-center">
                <el-pagination
                    background
                    v-loading="page.loading"
                    @current-change="currentChange"
                    :current-page="page.page"
                    :page-size="page.per_page"
                    layout="total, prev, pager, next, jumper"
                    :total="page.total"
                ></el-pagination>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    export default {
        components: {

        },
        props: ['value','item','defaultTitle','noClose','size'],
        data() {
            return {
                page:{
                    key: "",
                    loading: false,
                    total: 0,
                    page: 1,
                    per_page: 5,
                },
                tableData: [],
                dialogVisible: false,
                myValue: this.value,
                myItem: null
            }
        },
        computed: {
            title: function () {
                if(this.myItem){
                    if(this.myItem==='remove'){
                        return this.defaultTitle?this.defaultTitle:'请选择';
                    }else{
                        return this.myValue+' : '+this.myItem.name;
                    }
                }else{
                    if(this.item){
                        return this.item.id+' : '+this.item.name;
                    }else{
                        return this.defaultTitle?this.defaultTitle:'请选择';
                    }
                }
            }
        },
        mounted() {
            this.loadData(1);
        },
        methods: {
            loadData(page) {
                this.page.loading = true;
                this.page.page = page;
                this.choseLoad(res => {
                    this.tableData = res.data.data;
                    this.page.total = res.data.total;
                    this.page.loading = false;
                    console.log(res);
                });
            },
            choseLoad(callback){
                this.api.game_list(this.page,callback);
            },
            search() {
                this.loadData(1);
            },
            clear() {
                this.loadData(1);
            },
            currentChange(currentPage) {
                this.loadData(currentPage);
            },
            handleCurrentChange(val){
                if(!val) return;
                this.myItem=val;
                this.myValue=val.id;
                if(!this.noClose){
                    this.dialogVisible = false;
                }
            },
            remove(){
                this.myItem='remove';
                this.myValue=null;
            }
        },
        watch: {
            value(newValue) {
                this.myValue = newValue
            },
            myValue(newValue) {
                this.$emit('input', newValue)
            }
        }
    }

</script>